import { createContext } from 'react';
export function createClientContext(defaultValue) {
    // When on server, return undefined since we can't use contexts on e.g. Next.js server components
    if (typeof createContext === 'undefined')
        return undefined;
    return createContext(defaultValue);
}
//# sourceMappingURL=ContextUtils.js.map